import i18n from 'src/i18n'
import { CommentType } from 'src/components/postComments'
import { PostType } from 'src/hook/usePosts'
import { medias } from 'src/utils/constants'

export const getTitles = (i18n: { t: (key: string) => string }, isPost = false) => {
  const documentTitle = i18n.t('input_publish.button_send_pdf')
  const imageTitle = i18n.t('input_publish.button_send_image')
  const videoTitle = i18n.t('input_publish.button_send_video')
  const audioTitle = i18n.t('input_publish.button_send_audio')

  if (isPost) {
    return {
      [PostType.AUDIO]: {
        title: audioTitle
      },
      [PostType.DOCUMENT]: {
        title: documentTitle
      },
      [PostType.IMAGE]: {
        title: imageTitle
      },
      [PostType.VIDEO]: {
        title: videoTitle
      }
    }
  }

  return {
    [CommentType.AUDIO]: {},
    [CommentType.DOCUMENT]: {
      title: documentTitle
    },
    [CommentType.IMAGE]: {
      title: imageTitle
    },
    [CommentType.VIDEO]: {
      title: videoTitle
    }
  }
}

export const getDropZoneDataProps = (i18n: { t: (key: string) => string }, isPost = false) => {
  const documentData = {
    buttonLabel: i18n.t('input_publish.button_send_pdf'),
    text: i18n.t('input_publish.text_drag_and_drop_v2'),
    disclaimer: i18n.t('input_publish.message_pdf_format'),
    errorMessages: {
      invalidFileType: i18n.t('input_publish.message_pdf_format'),
      invalidFileSize: i18n.t('input_publish.message_pdf_format')
    },
    acceptedTypes: medias.pdf,
    maxSize: 20971520 // 20MB
  }
  const videoData = {
    buttonLabel: i18n.t('input_publish.button_send_video'),
    text: i18n.t('input_publish.text_drag_and_drop_v2'),
    disclaimer: i18n.t('input_publish.message_video_format_2'),
    errorMessages: {
      invalidFileType: i18n.t('input_publish.error.invalid_video_format')
    },
    acceptedTypes: medias.video
  }
  const imageData = {
    buttonLabel: i18n.t('input_publish.button_send_image'),
    text: i18n.t('input_publish.text_drag_and_drop_v2'),
    disclaimer: i18n.t('input_publish.message_image_format_2'),
    errorMessages: {
      invalidFileType: i18n.t('input_publish.error.invalid_image_format')
    },
    acceptedTypes: medias.image
  }
  const audioData = {
    buttonLabel: i18n.t('input_publish.button_send_audio'),
    text: i18n.t('input_publish.text_drag_and_drop_v2'),
    disclaimer: i18n.t('input_publish.message_audio_format'),
    errorMessages: {
      invalidFileType: i18n.t('input_publish.error.invalid_video_format'),
      invalidAudioDuration: i18n.t('input_publish.error.invalid_audio_duration')
    },
    acceptedTypes: medias.audio
  }

  if (isPost) {
    return {
      [PostType.AUDIO]: audioData,
      [PostType.DOCUMENT]: documentData,
      [PostType.VIDEO]: videoData,
      [PostType.IMAGE]: imageData
    }
  }

  return {
    [CommentType.AUDIO]: audioData,
    [CommentType.DOCUMENT]: documentData,
    [CommentType.VIDEO]: videoData,
    [CommentType.IMAGE]: imageData
  }
}

const useDropZoneDataProps = ({ mediaType, isPost = false }) => {
  const dropZoneDataProps = getDropZoneDataProps(i18n, isPost)
  const dropZoneProps = mediaType ? dropZoneDataProps[mediaType] : {}
  const titles = getTitles(i18n, isPost)
  const title = mediaType ? titles[mediaType]?.title : undefined

  return { title, dropZoneProps }
}

export default useDropZoneDataProps
